import { useMutation, useQuery } from '@tanstack/react-query';
import { activatePlan, createPlan, deletePlan, getPlans, updatePlan } from '@/features/agreements/services/plansService';

const BASE = 'plans';

export const plansQueryKeys = {
  base: () => [BASE],
  list: ({ agreementId, filters } = {}) => agreementId ? [BASE, 'list', agreementId, filters] : [BASE, 'list'],
};

export const useGetPlans = ({ agreementId, filters }, { enabled = true } = {}) => {
  return useQuery({
    queryKey: plansQueryKeys.list({ agreementId, filters }),
    queryFn: () => getPlans(agreementId, filters),
    enabled: enabled && !!agreementId,
  });
};

export const useCreatePlan = () => {
  return useMutation({
    mutationFn: ({ agreementId, data }) => createPlan(agreementId, data),
  });
};

export const useUpdatePlan = () => {
  return useMutation({
    mutationFn: ({ agreementId, planId, data }) => updatePlan(agreementId, planId, data),
  });
};

export const useActivatePlan = () => {
  return useMutation({
    mutationFn: ({ agreementId, planId }) => activatePlan(agreementId, planId),
  });
};

export const useDeletePlan = () => {
  return useMutation({
    mutationFn: ({ agreementId, planId }) => deletePlan(agreementId, planId),
  });
};
